import { useRecordLoader } from "./useRecordLoader";

export function useThreadRequests(props: {
  threadId?: string | null;
  recipientUserId?: string | null;
  senderUserId?: string | null;
}) {
  return useRecordLoader({
    name: "useThreadRequests",
    load({ loader, limit, deps: [threadId, senderUserId, recipientUserId] }) {
      if (!threadId) {
        return loader.createObserveQueryResult<"thread_request">();
      }

      return loader.observeGetThreadRequests({
        thread_id: threadId,
        sender_user_id: senderUserId ?? undefined,
        recipient_user_id: recipientUserId ?? undefined,
        limit,
      });
    },
    deps: [props.threadId, props.senderUserId, props.recipientUserId],
  });
}
